
define( 'FORCES_AND_MOTION_BASICS/../nls/fr/forces-and-motion-basics-strings',{
          "none": "nuls",
          "force": "force",
          "values": "valeurs",
          "frictionTitle": "frottements",
          "redWins": "les rouges gagnent !",
          "frictionForce": "force de frottement",
          "pause": "pause",
          "friction": "mouvement avec frottements",
          "forces-and-motion-basics.name": "forces et mouvement : pour débuter...",
          "appliedForce": "force appliquée",
          "leftForce": "force à gauche",
          "rightForce": "force à droite",
          "sound": "son",
          "lots": "forts",
          "forces": "forces",
          "motion": "mouvement sans frottement",
          "tugOfWar": "tir à la corde",
          "go": "tirez !",
          "sumOfForcesEqualsZero": "la somme des forces est nulle",
          "blueWins": "les bleus gagnent !",
          "speed": "vitesse",
          "sumOfForces": "somme des forces",
          "return": "retour",
          "translation.credits": "didier chartier, professeur de physique\nlycée jean moulin, gironde, 2012",
          "masses": "masses"
        } );